/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '../../services/toast';
export default {
  name: 'organization-create',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      name:'',
      email:'',
      address:'',
      city:'',
      pincode:'',
      country:''
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              name:this.name,
              email:this.email,
              address:this.address,
              city:this.city,
              pincode:this.pincode,
              country:this.country
            }
            this.$store.dispatch('createAcOrgFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);            
                  this.$router.push('/su/organization/');
              }).catch((err) => {
                toast.error(err.data.user_msg || err.data.data.email);  
              })
            return;
        }
      });
    }

  }
}


